import React from 'react';
import { useTranslation } from 'react-i18next';

const MemberOnlyTierLabel = () => {
  const { t } = useTranslation(['checkout']);
  return (
    <p className="flex items-center gap-1 bg-[#F6F6F6] text-sm font-semibold rounded-lg py-1 px-2">
      <img src="/img/community.svg" />
      <span className="text-[#787878] text-xs font-bold uppercase">
        {t('checkout:memberOnlyAccess')}
      </span>
    </p>
  );
};

export default MemberOnlyTierLabel;
